<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
            <li class="active">特殊精密场所振动监测</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px;font-size: 20px">特殊精密场所振动监测</h1>
            <hr>
            <p class="titleP">特殊精密场所振动监测的重要性</p>
            <p>环境振动是由场地周围自然振源和人工震源（机器振动源、交通工具等）所产生，表现为地面的一种稳定的非重复性的随机波动。通常情况下，环境振动具有频率低、振幅小的特点。环境振动具有不同的幅频变化和作用历时，因而会引起特殊精密场所的不同响应。特殊精密场所对环境振动的反应十分敏感，由于环境振动的大小直接影响特殊精密场所。</p>
            <p class="titleP">特殊精密场所振动控制标准</p>
            <div style="width:60%;margin: 0 auto 50px">
              <img src="../../../assets/center/precision/t1.png" alt="" style="width:100%;height:auto;">
            </div>
            <p class="titleP">特殊精密场所振动监测流程图</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/precision/f1.png" alt="" style="width:100%;height:auto;">
            </div>
            <p class="titleP">特殊精密场所振动监测案例</p>
            <p>测试概况：某集团公司是国内知名的光学元件生产商，新购进的光学检测仪器安装基础要求符合VC-B标准，受该公司委托，对基础进行了测试，经过团队成员共同努力，顺利完成了该测试</p>
            <p style="text-align: center">现场布置图</p>
            <div style="width:60%;margin: 0 auto 50px">
              <img src="../../../assets/center/precision/d1.jpg" alt="" style="width:100%;height:auto;">
            </div>
            <p style="text-align: center">测试结果图</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/precision/d2.png" alt="" style="width:100%;height:auto;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/precision/precision.vue